import { connect as formikConnect, Field } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../../lib/utils/css';
import { FormItemTypes } from '../constants';

import './FormRadio.scss';

/**
 * @param  {string} id - unique id for the form field
 * @param  {string} theme - Is fed by parent Form
 * @param  {string} name - FormCheckbox input title
 * @param  {string} label - FormCheckbox label text
 * @param  {string | Node} description - FormCheckbox text
 * @param  {string} qaTag - qaTag
 * @param  {Any} formik - Provided by formik connect
 */

class FormRadio extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    theme: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    checked: PropTypes.bool,
    innerRef: PropTypes.func,
    onChange: PropTypes.func,
    textPrimary: PropTypes.node,
    textSecondary: PropTypes.node,
    qaTag: PropTypes.string,
    formik: PropTypes.object,
    isNonBinaryGenderEnabled: PropTypes.bool,
    ariaDescribedby: PropTypes.string,
  };

  renderRadioText = (text, isSecondary, nonBinary) => {
    const textClasses = createBEM('Form__radio__text', {
      secondary: isSecondary,
      nonBinary,
    });
    return <div className={textClasses}>{text}</div>;
  };

  render() {
    const {
      id,
      name,
      theme,
      value,
      checked,
      innerRef,
      onChange,
      qaTag,
      formik,
      textPrimary,
      textSecondary,
      isNonBinaryGenderEnabled = false,
    } = this.props;
    const fieldProps = {
      id,
      name,
      value,
      innerRef,
      checked,
      type: FormItemTypes.RADIO,
      'aria-describedby': this.props.ariaDescribedby || this.props.id,
      'data-qa': qaTag,
    };

    if (typeof onChange === 'function') {
      fieldProps.onChange = event => {
        formik.handleChange(event);
        onChange(event);
      };
    }

    const formRadioClass = createBEM('Form__radio', {
      [theme]: !!theme,
      nonBinary: isNonBinaryGenderEnabled,
    });

    return (
      <label className={formRadioClass} key={name}>
        <div className='Form__radio__input__wrapper'>
          <Field className='Form__radio__input' {...fieldProps} />
          <span className='Form__radio__input--custom'></span>
        </div>
        <div className='Form__radio__text__container'>
          {this.renderRadioText(textPrimary, null, isNonBinaryGenderEnabled)}
          {this.renderRadioText(textSecondary, true)}
        </div>
      </label>
    );
  }
}

export default formikConnect(FormRadio);
